import { Auth0Client, User as Auth0User } from '@auth0/auth0-spa-js'
import { asyncPipe, pipe } from '@helo/utils'
import { StateCreator } from 'zustand'

import { Role } from '../../../config/roles'
import { User } from './AuthSlice.types'
import { AuthSliceParts } from './authSlice.parts'
import { AuthSliceActions } from './authSliceActions'

export type AuthState = {
  status: 'initial' | 'initializing' | 'started'
  /** Set at the start of `initializeAuth` from merged config. */
  auth0Client: Auth0Client | null
  roles: Role[]
  token?: string
  tokenIssuedAt: null | number
  tokenExpiresAt: null | number
  inactiveTimer: NodeJS.Timeout | null
  expirationTimer: NodeJS.Timeout | null
  user: User | null
  auth0Profile: Auth0User | null
  initialized: boolean
  initializing: boolean
  isAuthenticated: boolean
  isLoggingIn: boolean
  redirectTo: null | string
  // initialize: (reset?: boolean) => Promise<void>
  logout: () => Promise<AuthSlice>
  /**
   * Checks the users roles against the provided
   * roles to determine if one of the roles match.
   *
   * Will return true if no roles are provided.
   */
  hasRole: (roles?: Role[]) => boolean
}

export type AuthSlice = { auth: AuthState }
export const getPath = () =>
  `${window.location.pathname}${window.location.search}`
export const authSlice: StateCreator<AuthSlice, [], [], AuthSlice> = (
  set,
  get,
) => ({
  auth: {
    auth0Client: null,
    roles: [],
    initialized: false,
    status: 'initial',
    initializing: false,
    user: null,
    auth0Profile: null,
    isAuthenticated: false,
    token: undefined,
    redirectTo: null,
    tokenIssuedAt: null,
    tokenExpiresAt: null,
    inactiveTimer: null,
    expirationTimer: null,
    isLoggingIn: false,

    logout: () => asyncPipe(get(), AuthSliceActions.logout()),
    hasRole: (allowedRoles: Role[] = []) =>
      pipe(get(), AuthSliceParts.userHasRoles(allowedRoles)),
  },
})
